export default "__VITE_ASSET__DilIfv4g__"